<template>
    <div class="center tl-ns mb4">
        <div :class="{'flex items-center' : !xs}">
            
            <img style="border-radius: 50%; width: 75px;" src="@/assets/img/avatars/avatar_1.svg">
            
            <div :class="{'mt2' : xs, 'ml3' : !xs}">
                <h6>{{data.name}}</h6>
                <div>on {{data.date}}</div>
            </div>
        </div>

        <div class="mt2 dib">
            <star-rating 
            :rating="data.rating"
            :increment=".5"
            :read-only="true"
            :show-rating="false"
            :star-size="20"
            active-color="#FB0"
            inactive-color="#DDE2E6"
            />
        </div>
        <h5 class="mt2">{{data.title}}</h5>
        <div class="mt2">{{data.description}}</div>
    </div>
</template>

<script>
import StarRating from 'vue-star-rating';

export default {
    components: {
        StarRating
    },
    props: {
        data: {
            type: Object
        }
    },
    computed: {
        xs() {
            return this.$mq === 'xs';
        }
    }
};
</script>
